import type { InputBinding } from '@/types/multiplayer';

export function escapeHtml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

export function formatBinding(binding: InputBinding): string {
  if (binding.type === 'mouse') return binding.mouseButton === 2 ? 'RMB' : 'LMB';

  const key = binding.key;
  if (key === ' ' || key === 'SPACE') return 'SPACE';
  if (key === 'ESCAPE') return 'ESC';
  if (key === 'ENTER') return 'RETURN';
  if (key === 'ARROWUP') return 'UP';
  if (key === 'ARROWDOWN') return 'DOWN';
  if (key === 'ARROWLEFT') return 'LEFT';
  if (key === 'ARROWRIGHT') return 'RIGHT';
  return key;
}

